import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ConsoleHomeService } from 'src/app/core/services/console-home.service';
import { environment } from 'src/environments/environment';
import { WorkspaceService } from 'src/app/core/services/workspace.service';
@Component({
  selector: 'vcp-left-side-nav',
  templateUrl: './left-side-nav.component.html',
  styleUrls: ['./left-side-nav.component.scss']
})
export class LeftSideNavComponent implements OnInit {
  @Input() selectedModule;
  @Input() userData;
  @Output() sidebarToggle = new EventEmitter<boolean>();
  selectedWorkspace: any;
  accountId: any;
  accountName: any;
  orgId: any;
  orgName: any;
  constructor(
    private readonly us: UtilityService,
    private readonly consoleService: ConsoleHomeService,
    private workspaceService: WorkspaceService
  ) {
  }

  ngOnInit(): void {
    this.getWorkspaceList();
  }

  getWorkspaceList(){
    let data = {userId: this.us.getUserId()};
    const query = this.us.getObjToQueryParam(data);
    this.consoleService.getAccountWorkspaceList(query).subscribe(res =>{
      if (res && res['code'] === 'success') {
        this.selectedWorkspace = res['data'].find(w => w.workspaceHierarchy === this.us.getWorkspaceAccessLevel());
        if(!this.selectedWorkspace){
          this.selectedWorkspace = res['data'][0];
        }
        this.accountId = this.selectedWorkspace['accountId'];
        this.accountName = this.selectedWorkspace['accountName'];
        this.orgId = this.selectedWorkspace['workspaceId'];
        this.orgName = this.selectedWorkspace['workspaceName'];
        this.us.setWorkSpaceName(this.orgName);
      }
    });
  }


  expandLeftMenu() {
    const leftmenu = document.getElementById('leftmenu');
    if (!this.us.isLeftMenuOpen) {
      leftmenu.classList.add('expanded');
      document.getElementById('expTool').innerText = 'Close';
    } else {
      leftmenu.classList.remove('expanded');
      document.getElementById('expTool').innerText = 'Expand';
    }
    this.us.isLeftMenuOpen = !this.us.isLeftMenuOpen;
    this.sidebarToggle.emit(true);
  }

  callsslTokenApi(){
    this.consoleService.generatesslTokenApi().subscribe(
      (res: any) => {
        console.log(res);
        let data = res['GENERATE_SSO_TOKEN']['records'][0]['data'];
        if (data && data[0]['status'] === 'SUCCESS') {
          const ssoToken = data[0]['ssoToken'];
          const loginId = this.us.getUserName();
          const version = 'v2';
          const accountId = this.us.getDefaultAccountId();
          const accountName = this.us.getCookie('DEFAULT_ACCOUNT_NAME');
          const userId = this.us.getUserId();
          const orgId = this.us.getWorkspaceId();
          const orgName = this.us.getWorkSpaceName();

          const url = `https://support.vahanacloud.com/portal/#/main/1683200948084966/LANDING?sso_token=${ssoToken}&loginId=${loginId}&version=${version}&accountId=${accountId}&accountName=${accountName}&from=accountPortal&userId=${userId}&orgId=${orgId}&orgName=${orgName}`;
          window.open(url, '_blank');
        } else {
          console.log('Something went wrong');
          this.us.openSnackBar(data[0]['message']);
        }
      },
      (err: any) => {
        console.log(err);
      },
    );
  }

  openvAcademy(){
    const path = this.selectedModule?.type === 'profile'?'get-started-with-vahana/profile-settings/':'get-started-with-vahana/an-introduction-to-vahana-cloud/';
     const url = `${environment.vAcademyUrl}${path}`;
     window.open(url, path);
  }

  goToCommunity(){
    window.open(this.us.modules['community']['url'],this.us.modules['community']['title']);
  }

}
